export default __webpack_public_path__ + "static/granulation-6ac97a6b6a27b79148358a4cc6a010f3.png";